export default function describeByString( array, type ) {
    let string = null;

    array.forEach( ( item, index ) => {
        if ( index === 0 ) {
            string = `${type}${index}`;
        } else {
            string += ` ${type}${index}`;
        }
    } );

    return string;
}
